import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { Box } from "@mui/system";

export default function SkeletonSingleArticle({ image }) {
  return (
    <Stack spacing={1}>
      {/* For variant="text", adjust the height via font-size */}
      {image && <Skeleton variant="rectangular" width="100%" height={425} />}
      <Skeleton variant="text" width='60%' />
      {image && <Skeleton variant="text" width={200} />}
      <Skeleton variant="text" width="100%" />
      <Skeleton variant="text" width="100%" />
      <Skeleton variant="text" width="100%" />
      {!image && (
        <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
          <Skeleton variant="text" width={150} />
          <Skeleton variant="rectangular" width={120} height={30}/>
        </Box>
      )} 
      {/* For other variants, adjust the size with `width` and `height` */}
      {/* <Skeleton variant="circular" width={40} height={40} />
      <Skeleton variant="rounded" width={210} height={60} /> */}
    </Stack>
  );
}
